import { createContext, useContext } from 'react';
import { APP_HEX } from '@/constant/theme/colors.constant';

/** 'system' = follow the OS/browser preference automatically */
export type Theme = 'light' | 'dark' | 'system';

export interface ThemeColors {
  primary: string;
  secondary: string;
  tertiary: string;
}

export const DEFAULT_THEME_COLORS: ThemeColors = {
  primary: APP_HEX.primary,
  secondary: APP_HEX.secondary,
  tertiary: APP_HEX.tertiary,
};

export interface ThemeContextType {
  /** The user's stored preference: 'light' | 'dark' | 'system' */
  theme: Theme;
  /** The resolved (actual) mode being applied to the UI */
  resolvedTheme: 'light' | 'dark';
  /** Cycle: light → dark → system */
  toggleTheme: () => void;
  /** Directly set a specific mode */
  setTheme: (theme: Theme) => void;
  isDark: boolean;
  colors: ThemeColors;
  setColors: (colors: ThemeColors) => void;
}

export const ThemeContext = createContext<ThemeContextType>({
  theme: 'system',
  resolvedTheme: 'light',
  toggleTheme: () => { },
  setTheme: () => { },
  isDark: false,
  colors: DEFAULT_THEME_COLORS,
  setColors: () => { },
});

export const useTheme = () => useContext(ThemeContext);
